export const B2C_BASE_URL = `https://${process.env.AZURE_AD_B2C__TENANT}.b2clogin.com/${process.env.AZURE_AD_B2C__TENANT}.onmicrosoft.com`;
export const B2C_CALLBACK_ROUTE_URL = 'b2c';